import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { catchError, switchMap, tap, take, share } from 'rxjs/operators';
import { LoginResponse } from '../models/responses/login.response';
import { Router } from '@angular/router';
import { EMPTY, of, timer, interval, } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { merge, Subscription } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { ChallengeInlineDialogComponent } from 'src/app/shared/modules/challenge-inline-dialog/components/challenge-inline-dialog/challenge-inline-dialog.component';
import { ChallengeInlineDialogExpiredComponent } from 'src/app/shared/modules/challenge-inline-dialog-expired/components/challenge-inline-dialog-expired/challenge-inline-dialog-expired.component';
import { FirebaseService } from './firebase.service';
//import { ChallengeInlineDialogComponent } from './challenge-inline.dialog';

const REMEMBER_AUTH_KEY = '__AU'
const RANDOM_KEY = 'rk_sd'
@Injectable({ providedIn: 'root' })
export class AuthService {

  constructor(private api: ApiService, private dialog: MatDialog,
    private firebaseService: FirebaseService,
    private router: Router) {
  }

  // public authenticate({ userName, password }: { userName: string, password: string }, remember: boolean = true) {
  //   return this.api.login({ userName, password })
  //     .pipe(tap(res => {
  //       if (res.status === 3) {
  //         const dlgRef = this.dialog.open(ChallengeInlineDialogComponent, {
  //           disableClose: true,
  //           width: '480px',
  //           data: { data: res }
  //         });

  //         const deadline$ = timer(50000).pipe(share());
  //         const stop$ = merge(dlgRef.afterClosed(), deadline$);
  //         const ticks$ = interval(5000);
  //         const sub: Subscription = ticks$
  //           .pipe(
  //             takeUntil(stop$),
  //             tap(i => console.log('[poll tick]', i)),
  //             switchMap(() =>
  //               this.api.getAccessToken({ token: res.token }).pipe(
  //                 tap(() => console.log('[http] getAccessToken called')),
  //                 catchError(err => {
  //                   console.error('getAccessToken failed:', err);
  //                   dlgRef.componentInstance?.setError('Still waiting for approval…');
  //                   return of(null);
  //                 })
  //               )
  //             ),
  //             tap((r: any) => {
  //               if (r && r.status === -1) {
  //                 sub?.unsubscribe?.();
  //                 dlgRef.close();
  //                 dlgRef.afterClosed().pipe(take(1)).subscribe(() => {
  //                   const dlgFail = this.dialog.open(ChallengeInlineDialogExpiredComponent, {
  //                     disableClose: true,
  //                     width: '480px',
  //                     data: {
  //                       isExpired: false,
  //                       isFailed: true
  //                     }
  //                   });
  //                   timer(3000).pipe(take(1)).subscribe(() => dlgFail.close());
  //                 });
  //               }
  //             }),
  //             filter((tokenRes: any) => !!tokenRes && tokenRes.status === 1)
  //           )
  //           .subscribe((tokenRes: any) => {

  //             sub.unsubscribe();
  //             dlgRef.close();

  //             this.onAuthenticated(tokenRes);
  //             if (remember) this.rememberUser(userName, password);
  //             else this.removeRememberUser();
  //             this.router.navigate(['/']);
  //           });
  //         deadline$.subscribe(() => {
  //           if (dlgRef.getState ? dlgRef.getState() !== 2 : true) {
  //             dlgRef.close();
  //             const dlgEx = this.dialog.open(ChallengeInlineDialogExpiredComponent, {
  //               disableClose: true,
  //               width: '480px',
  //               data: {
  //                 isExpired: true,
  //                 isFailed: false
  //               }
  //             });
  //             timer(5000).pipe(take(1)).subscribe(() => {
  //               dlgEx.close();
  //             });
  //           }
  //         });
  //       }

  //       if ((res.status === 1) || (res.status === 2)) {
  //         this.onAuthenticated(res);
  //         if (remember) {
  //           this.rememberUser(userName, password);
  //         } else {
  //           this.removeRememberUser();
  //         }
  //       }

  //       else {
  //         if (this.router.url != '/sign-in') {
  //           this.signOut();
  //         }
  //         throw new Error(res.message);
  //       }
  //     }));
  // }

  public authenticate({ userName, password }: { userName: string; password: string }, remember: boolean = true) {
    return this.api.login({ userName, password }).pipe(
      tap(res => {
        if (res.status === 3) {
          const dlgRef = this.dialog.open(ChallengeInlineDialogComponent, {
            disableClose: true,
            width: '480px',
            data: { data: res }
          });

          this.firebaseService.initRealTimeDB(res);
          const fbSub = this.firebaseService.status$
            .pipe(
              filter(data => !!data),
              switchMap(() =>
                this.api.getAccessToken({ token: res.token })
              )
            )
            .subscribe((tokenRes: any) => {
              if (tokenRes.status === 1) {
                fbSub.unsubscribe();
                this.firebaseService.detachListener();
                dlgRef.close();

                this.onAuthenticated(tokenRes);
                if (remember) this.rememberUser(userName, password);
                else this.removeRememberUser();
                this.router.navigate(['/']);
              }

              if (tokenRes.status === -1) {
                fbSub.unsubscribe();
                this.firebaseService.detachListener();
                dlgRef.close();

                const dlgFail = this.dialog.open(ChallengeInlineDialogExpiredComponent, {
                  disableClose: true,
                  width: '480px',
                  data: { isExpired: false, isFailed: true, errorMsg: tokenRes.message || 'Authentication failed.' }
                });

                timer(3000).pipe(take(1)).subscribe(() => dlgFail.close());
              }
            });

          dlgRef.afterClosed().pipe(take(1)).subscribe(result => {
            fbSub.unsubscribe();
            this.firebaseService.detachListener();

            if (result === 'resend') {
              this.authenticate({ userName, password }, remember).subscribe();
            }
          });
        } else if (res.status === 1 || res.status === 2) {
          this.onAuthenticated(res);
          if (remember) this.rememberUser(userName, password);
          else this.removeRememberUser();
          this.router.navigate(['/']);
        } else {
          if (this.router.url !== '/sign-in') this.signOut();
          throw new Error(res.message);
        }
      })
    );
  }

  changePassword(newPassword: string, oldPassword: string) {
    let data = this.getRememberUser();
    if (data) {
      return this.api.changeOwnPassword(newPassword, oldPassword)
        .pipe(tap(res => {
          if (res.status === 1) {
            this.rememberUser(data.userName, newPassword);
          }
        }));
    }

    return this.api.changeOwnPassword(newPassword, oldPassword);
  }

  reauthenticate() {
    let data = this.getRememberUser();
    if (data && data.userName && data.password) {
      return this.authenticate(data, true)
    } else {
      this.signOut();
      return EMPTY
    }
  }

  refreshToken(refreshToken: string) {
    if (refreshToken) {
      return this.api.refreshToken({ refreshToken });
    } else {
      this.signOut();
      return EMPTY;
    }
  }

  getRefreshToken(): string | null {
    return localStorage.getItem('refresh_token');
  }

  private rememberUser(userName: string, password: string) {
    const prefix = btoa(REMEMBER_AUTH_KEY).replace(/=/g, '');
    const base64 = REMEMBER_AUTH_KEY.replace(/_/g, '') + btoa(userName + ',' + REMEMBER_AUTH_KEY.toLocaleLowerCase() + password);
    const random = new Date().getTime().toString(16);
    localStorage.setItem(RANDOM_KEY, random)
    localStorage.setItem(REMEMBER_AUTH_KEY, prefix + btoa(prefix + random.substr(random.length - 4) + base64));
  }

  private removeRememberUser() {
    localStorage.removeItem(REMEMBER_AUTH_KEY);
  }

  getRememberUser(): { userName: string, password: string } {
    const prefix = btoa(REMEMBER_AUTH_KEY).replace(/=/g, '');
    const item = localStorage.getItem(REMEMBER_AUTH_KEY);
    const random = localStorage.getItem(RANDOM_KEY);
    if (!item) {
      return null;
    }
    try {
      const data = atob(item.replace(prefix, ''))
      const base64 = data.replace(prefix + random.substr(random.length - 4), '').replace(REMEMBER_AUTH_KEY.replace(/_/g, ''), '');
      const [userName, password] = atob(base64).split(',' + REMEMBER_AUTH_KEY.toLocaleLowerCase());
      return { userName, password }
    } catch (error) {
      return null;
    }
  }

  public hasLoggedIn(): boolean {
    return !!this.getToken();
  }

  public saveToken(token: string, refreshToken?: string) {
    localStorage.setItem('access_token', token);
    localStorage.setItem('refresh_token', refreshToken);
  }

  public saveUserRole(userRoleID: string) {
    localStorage.setItem('user_role_id', userRoleID);
  }

  public saveEnableSeparateStampFeature(enable_separate_stamp_feature: boolean) {
    localStorage.setItem('enable_separate_stamp_feature', String(enable_separate_stamp_feature));
  }

  private saveUserID(userID: string) {
    localStorage.setItem('user_id', userID);
  }

  public saveLocale(locale: string) {
    localStorage.setItem('locale', locale);
  }

  public saveGroupPriority(is_priority: boolean) {
    localStorage.setItem('group_priority', is_priority ? 'true' : '');
  }

  public saveGroupID(_id: string) {
    localStorage.setItem('group_id', _id || '');
  }

  public getGroupID() {
    return localStorage.getItem('group_id');
  }

  public isUserGroupPriority() {
    return localStorage.getItem('group_priority') == 'true';
  }

  public getToken(): string {
    return localStorage.getItem('access_token');
  }

  public clearToken() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  }

  public async signOut() {
    this.clearToken();
    this.removeRememberUser()
    await this.router.navigate(['/sign-in']);
  }

  public onAuthenticated(response: LoginResponse) {
    this.saveToken(response.token, response.refresh_token);
    this.saveUserRole(response.user.role);
    this.saveUserID(response.user._id);
    this.saveGroupID(response.user.group?._id)
    this.saveGroupPriority(response.user.group?.is_priority);
    this.saveEnableSeparateStampFeature(response?.enable_separate_stamp_feature);
  }
}
